import { Component } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixTextComponent } from "../../prefix-text.component";
import { TemplateTextComponent } from "../../templates/template-text/template-text.component";
import { MaxLength } from "../../types/MaxLength";

@Component({
  selector: "app-prefix-nvv",
  imports: [TemplateTextComponent],
  templateUrl: "./prefix-nvv.component.html",
  styleUrl: "./prefix-nvv.component.less",
})
export class PrefixNvvComponent extends PrefixTextComponent {
  public maxlength: MaxLength;

  public constructor() {
    super();
    this.maxlength = 8;
    this.characters = ALLOWED_CHARACTERS["nvv"];
  }
}
